export default "__VITE_ASSET__810299df__"